import { render, staticRenderFns } from "./NotificationDrawer.vue?vue&type=template&id=204c59e9&scoped=true&"
import script from "./NotificationDrawer.vue?vue&type=script&lang=js&"
export * from "./NotificationDrawer.vue?vue&type=script&lang=js&"
import style0 from "./NotificationDrawer.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./NotificationDrawer.vue?vue&type=style&index=1&id=204c59e9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "204c59e9",
  null
  
)

export default component.exports